// extracted by mini-css-extract-plugin
module.exports = {"container":"menu_container__P0bBf","panel":"menu_panel__1nJQu","userLogin":"menu_userLogin__Sa57K"};